export const helpContentSelector = state => {
  return state.recentActivity.reportActivity || "";
};
